import { render, staticRenderFns } from "./StrategySettingsPage.vue?vue&type=template&id=5a4d05e4"
import script from "./StrategySettingsPage.vue?vue&type=script&lang=ts"
export * from "./StrategySettingsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports